import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib';
import { ModalCyber } from '@shared/ui/molecules';
import { FetchHintsResponseType } from '@entities/hint';
interface NewAccountInstructionsModalProps {
  isOpen: boolean;
  handleClose: () => void;
  content: FetchHintsResponseType['steam']['newAccounts'];
}
const NewAccountInstructionsModal: FC<NewAccountInstructionsModalProps> = ({
  isOpen,
  handleClose,
  content
}) => <ModalCyber title={content.title} content={<StepsList>
        {content.steps.map((item, index) => <StepItem key={item}>
            <StepNumber>{index + 1}</StepNumber>
            <StepText>{item}</StepText>
          </StepItem>)}
      </StepsList>} handleClose={handleClose} open={isOpen} />;
export default NewAccountInstructionsModal;
const StepsList = /*#__PURE__*/styled('div')({
  name: "StepsList",
  class: "sb6q5uy",
  propsAsIs: false
});
const StepItem = /*#__PURE__*/styled('div')({
  name: "StepItem",
  class: "s1nhpgk0",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.state.active;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.white;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.bold;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxs;
const StepNumber = withTheme(/*#__PURE__*/styled('div')({
  name: "StepNumber",
  class: "sq3dg33",
  propsAsIs: false,
  vars: {
    "sq3dg33-0": [_exp()],
    "sq3dg33-1": [_exp2()],
    "sq3dg33-2": [_exp3()],
    "sq3dg33-3": [_exp4()],
    "sq3dg33-4": [_exp5(), "px"]
  }
}));
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const _exp7 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const StepText = withTheme(/*#__PURE__*/styled('div')({
  name: "StepText",
  class: "s13hopy2",
  propsAsIs: false,
  vars: {
    "s13hopy2-0": [_exp6()],
    "s13hopy2-1": [_exp7()]
  }
}));

require("./NewAccountInstructionsModal.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./NewAccountInstructionsModal.tsx");